import { render, staticRenderFns } from "./CadastroPedido.vue?vue&type=template&id=59917a85"
import script from "./CadastroPedido.vue?vue&type=script&lang=js"
export * from "./CadastroPedido.vue?vue&type=script&lang=js"
import style0 from "./CadastroPedido.vue?vue&type=style&index=0&id=59917a85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports